import axios from "axios";


//get time entries
const getTimeEntries = async (filter = {})=>{
  try {
    const response = await axios.get("api/v1/entries/all", { params: filter });
    return response.data;
  } catch (error) {
    // Handle error
    console.error("Get time entries error:", error);
    throw error; // Rethrow the error to propagate it to the caller
  }
};

//get current user time entries
const getUserTimeEntries = async (user, filter = {})=>{
  try {
    const token = user.access;
    const response = await axios.get("api/v1/entries/employees", { 
      headers: { Authorization: `Bearer ${token}` },
      params: filter ,
    });
  return response.data;
  } catch (error) {
    // Handle error
    console.error("Get user time entries error:", error);
    throw error; // Rethrow the error to propagate it to the caller
  }
};
  

//get active time entries
const getAllActiveTimeEntries = async ()=>{
  try {
    const response = await axios.get("api/v1/entries/active");
    return response.data;
  } catch (error) {// Handle error
    console.error("Get all active time entries error:", error);
    throw error; // Rethrow the error to propagate it to the caller
  }
};


//get unverified time entries
const getUnverifiedTimeEntries = async ()=>{
  try {
    const response = await axios.get("api/v1/entries/unverified");
    return response.data;
  } catch (error) {
    // Handle error
    console.error("Get unverified time entries error:", error);
    throw error; // Rethrow the error to propagate it to the caller
  }
};

// Create a new entry
const createEntry = async (entryData, user) => {
  try {
    const token = user.access;
    const response = await axios.post(
      "/api/v1/entries/create/", 
      entryData,
      {
        headers: 
        { Authorization: `Bearer ${token}`} 
      }
    );
    return response.data;
  } catch (error) {
    // Handle error
    console.error("Create entry error:", error);
    throw error; // Rethrow the error to propagate it to the caller
  }
};

// Update an active entry
const updateEntry = async (id, entryData, user) => {
  try {
    const token = user.access;
    const response = await axios.put(
      `/api/v1/entries/update/${id}/`, 
      entryData,
      {
        headers: 
        { Authorization: `Bearer ${token}`} 
      }
    );
    return response.data;
  } catch (error) {
    // Handle error
    console.error("Update entry error:", error);
    throw error; // Rethrow the error to propagate it to the caller
  }
};

const entryAPIService = { 
    getTimeEntries, 
    getUserTimeEntries,
    getUnverifiedTimeEntries, 
    getAllActiveTimeEntries, 
    createEntry, 
    updateEntry 
};

export default entryAPIService;
